import { Injectable, signal } from '@angular/core';
import { AppLanguage, LanguageOption, SUPPORTED_LANGUAGES } from './translations';

const STORAGE_KEY = 'lem:language';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  private readonly languageSignal = signal<AppLanguage>('fr');

  readonly language = this.languageSignal.asReadonly();
  readonly options: readonly LanguageOption[] = SUPPORTED_LANGUAGES;

  constructor() {
    this.enforceFrench();
  }

  setLanguage(_language: AppLanguage): void {
    this.enforceFrench();
  }

  /** LEM est actuellement distribué uniquement en français. */
  setFromAccount(_language: string | null | undefined): void {
    this.enforceFrench();
  }

  translate(value: string | null | undefined): string {
    return value ?? '';
  }

  private enforceFrench(): void {
    this.languageSignal.set('fr');
    try {
      localStorage.setItem(STORAGE_KEY, 'fr');
    } catch {
      // Le français reste actif même si le stockage navigateur est bloqué.
    }
    document.documentElement.lang = 'fr';
    document.documentElement.dataset['lemLanguage'] = 'fr';
  }
}
